import type { Zone } from '@seek/audience-zones';
import type {
  TExperimentKeys,
  TSeekExperiments,
} from 'src/store/experiments/experimentHelpers';
import type { TypedAction } from 'src/store/reducer';

const EXPERIMENTS_INITIALISED = '__EXPERIMENTS_INITIALISED';

/**
 * See https://myseek.atlassian.net/wiki/spaces/TDA/pages/2056519973/Experimentation
 * for experiment specs.
 */

export type TExperimentNames = 'split_view_anz_6' | 'job_salary_badge';

export interface TExperiment {
  name: TExperimentNames;
  percentage: number;
  num: number;
  targetZones: Set<Zone>;
  groupSalt?: string;
  enableTrackingForZeroPercent?: boolean;
}

export type TFeatureExperiments = Partial<Record<TExperimentKeys, TExperiment>>;
const SPLIT_VIEW_ANZ_GROUP_SALT = 'SPLIT_VIEW_ANZ_6';
const SALARY_TRANSPARENCY_GROUP_SALT = 'JOB_SALARY_BADGE';

export const FEATURE_EXPERIMENTS: TFeatureExperiments = {
  splitView: {
    name: 'split_view_anz_6',
    percentage: 20, // to be 10:10:80
    enableTrackingForZeroPercent: true,
    num: 5,
    targetZones: new Set<Zone>(['anz-1', 'anz-2']),
    groupSalt: SPLIT_VIEW_ANZ_GROUP_SALT,
  },
  salaryTransparency: {
    name: 'job_salary_badge',
    percentage: 0,
    enableTrackingForZeroPercent: true,
    num: 6,
    targetZones: new Set<Zone>([
      'anz-1',
      'anz-2',
      'asia-1',
      'asia-3',
      'asia-4',
      'asia-5',
      'asia-6',
      'asia-7',
    ]),
    groupSalt: SALARY_TRANSPARENCY_GROUP_SALT,
  },
};

export interface UpdateExperimentsAction {
  type: typeof EXPERIMENTS_INITIALISED;
  payload: TSeekExperiments;
}

export type ExperimentsState = TSeekExperiments;

export const initialState: ExperimentsState = {};

export const experimentsIntialised = (
  experiments: TSeekExperiments,
): UpdateExperimentsAction => ({
  type: EXPERIMENTS_INITIALISED,
  payload: experiments,
});

export const reducer = (state = {}, action: TypedAction) => {
  switch (action.type) {
    case EXPERIMENTS_INITIALISED: {
      return {
        ...state,
        ...action.payload,
      };
    }

    default:
      return state;
  }
};
